import { BaseService } from "@/services/BaseService";
import type { PermissionCatalogItem } from "@/types/permission-catalog";
import type {
  CreatePlatformCustomRoleDto,
  PlatformCustomRole,
  PlatformCustomRoleListQuery,
  PlatformPermissionCatalogQuery,
  PlatformRoleAssignment,
  PlatformRoleAssignmentResult,
  UpdatePlatformCustomRoleDto,
} from "@/types/platform-role";

class PlatformPermissionsService extends BaseService {
  getPermissions(
    query?: PlatformPermissionCatalogQuery,
  ): Promise<PermissionCatalogItem[]> {
    return this.get<PermissionCatalogItem[]>(
      "/admin/platform-permissions",
      query,
      {
        skipSelectedHotelHeader: true,
      },
    );
  }

  getRoles(query?: PlatformCustomRoleListQuery): Promise<PlatformCustomRole[]> {
    return this.get<PlatformCustomRole[]>("/admin/platform-roles", query, {
      skipSelectedHotelHeader: true,
    });
  }

  getRole(id: string): Promise<PlatformCustomRole> {
    return this.get<PlatformCustomRole>(
      `/admin/platform-roles/${id}`,
      undefined,
      {
        skipSelectedHotelHeader: true,
      },
    );
  }

  createRole(
    payload: CreatePlatformCustomRoleDto,
  ): Promise<PlatformCustomRole> {
    return this.request<PlatformCustomRole>("/admin/platform-roles", {
      method: "POST",
      body: JSON.stringify(payload),
      skipSelectedHotelHeader: true,
    });
  }

  updateRole(
    id: string,
    payload: UpdatePlatformCustomRoleDto,
  ): Promise<PlatformCustomRole> {
    return this.request<PlatformCustomRole>(`/admin/platform-roles/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
      skipSelectedHotelHeader: true,
    });
  }

  deleteRole(id: string): Promise<void> {
    return this.request<void>(`/admin/platform-roles/${id}`, {
      method: "DELETE",
      skipSelectedHotelHeader: true,
    });
  }

  replaceUserRoles(
    userId: string,
    customRoleIds: string[],
  ): Promise<PlatformRoleAssignmentResult> {
    return this.request<PlatformRoleAssignmentResult>(
      `/admin/users/${userId}/platform-roles`,
      {
        method: "PUT",
        body: JSON.stringify({ customRoleIds }),
        skipSelectedHotelHeader: true,
      },
    );
  }

  getUserRoles(userId: string): Promise<PlatformRoleAssignment[]> {
    return this.get<PlatformRoleAssignment[]>(
      `/admin/users/${userId}/platform-roles`,
      undefined,
      { skipSelectedHotelHeader: true },
    );
  }
}

export const platformPermissionsService = new PlatformPermissionsService();
